// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-widget__sendable{margin:0px;border-radius:0px;background:var(--background--highlight)}.c-widget__sendable-header{height:40px;position:relative;display:flex;align-items:center;justify-content:center;background-color:var(--background)}.c-widget__sendable-header-text{font-size:16px;font-weight:700}.c-widget__sendable-header__close-button{width:28px;height:28px;position:absolute;right:0;margin-right:8px;color:var(--text);border:rgba(0,0,0,0)}", ""]);
// Exports
module.exports = exports;
